import {
  GET_PLAYER_SCORE_LOADING,
  GET_PLAYER_SCORE_SUCCESS,
  GET_PLAYER_SCORE_ERROR
} from "../../../constant/actionTypes";
import { apiPost, apiGet } from "../../../utils/apiRequests";
import ApiEndpoints from "../../../utils/ApiEndpoints";

export const getPlayerScore = (playerId) => (dispatch) => {
  dispatch({ type:   GET_PLAYER_SCORE_LOADING  });
  apiGet(
    `${ApiEndpoints.player.base}/getscores/${playerId}`,
    (response) => {
      // console.log("get players response ==============> ", response);
      if (response.error == true) {
        dispatch({ type: GET_PLAYER_SCORE_ERROR, response: response.message });
      } else {
        dispatch({ type: GET_PLAYER_SCORE_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_PLAYER_SCORE_ERROR, response: error });
    }
  );
}